import { IHealthProblemHocSinhItemRequest } from "../../../models/request/y-te/yTeRequests";
import {
	IHealthProblemByHocSinhRequest,
	IStudentMedicalHistoryDetailSelectRequest,
	IStudentMedicalHistorySelectRequest
} from "../../../models/request/y-te/studentMedicalHistoryRequests";
import {
	HealthProblemHocSinhItemResponse,
	StudentMedicalHistoryDetailItemResponse,
	StudentMedicalHistoryItemResponse
} from "../../../models/response/y-te/healthproblem";
import { IStudentMedicalHistoryHocSinh } from "../../../models/response/y-te/studentMedicalHistory";
import {
	eStudentMedicalHistoryActionTypeIds,
	IStudentMedicalHistoryChangeHealthProblems,
	IStudentMedicalHistoryChangeHocSinhSelected,
	IStudentMedicalHistoryCloseConfirm,
	IStudentMedicalHistoryDeleteErr,
	IStudentMedicalHistoryDeleteStart,
	IStudentMedicalHistoryDeleteSuccess,
	IStudentMedicalHistoryExportCompleted,
	IStudentMedicalHistoryLoadByHocSinhErr,
	IStudentMedicalHistoryLoadByHocSinhStart,
	IStudentMedicalHistoryLoadByHocSinhSuccess,
	IStudentMedicalHistoryLoadErr,
	IStudentMedicalHistoryLoadExportErr,
	IStudentMedicalHistoryLoadExportStart,
	IStudentMedicalHistoryLoadExportSuccess,
	IStudentMedicalHistoryLoadHocSinhErr,
	IStudentMedicalHistoryLoadHocSinhStart,
	IStudentMedicalHistoryLoadHocSinhSuccess,
	IStudentMedicalHistoryLoadStart,
	IStudentMedicalHistoryLoadSuccess,
	IStudentMedicalHistorySaveErr,
	IStudentMedicalHistorySaveStart,
	IStudentMedicalHistorySaveSuccess,
	IStudentMedicalHistoryShowConfirm
} from "../../action-types/y-te/IStudentMedicalHistoryActionTypes";

export const studentMedicalHistoryActions = {
	loadStudentMedicalHistoryStart: (request: IStudentMedicalHistorySelectRequest): IStudentMedicalHistoryLoadStart => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadStudentMedicalHistorySuccess: (data: StudentMedicalHistoryItemResponse[]): IStudentMedicalHistoryLoadSuccess => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadStudentMedicalHistoryError: (message: string): IStudentMedicalHistoryLoadErr => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadStudentMedicalHistoryExportStart: (request: IStudentMedicalHistoryDetailSelectRequest): IStudentMedicalHistoryLoadExportStart => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_START,
			payload: request
		}
	},
	loadStudentMedicalHistoryExportSuccess: (data: StudentMedicalHistoryDetailItemResponse[]): IStudentMedicalHistoryLoadExportSuccess => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_SUCCESS,
			payload: data
		}
	},
	loadStudentMedicalHistoryExportError: (message: string): IStudentMedicalHistoryLoadExportErr => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_ERROR,
			payload: message
		}
	},
	studentMedicalHistoryExportCompleted: (): IStudentMedicalHistoryExportCompleted => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.EXPORT_COMPLETED
		}
	},
	loadStudentMedicalHistoryHocSinhStart: (ts_hocsinh_id: number): IStudentMedicalHistoryLoadHocSinhStart => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_START,
			payload: ts_hocsinh_id
		}
	},
	loadStudentMedicalHistoryHocSinhSuccess: (data: IStudentMedicalHistoryHocSinh): IStudentMedicalHistoryLoadHocSinhSuccess => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_SUCCESS,
			payload: data
		}
	},
	loadStudentMedicalHistoryHocSinhError: (message: string): IStudentMedicalHistoryLoadHocSinhErr => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_ERROR,
			payload: message
		}
	},
	changeStudentMedicalHistoryHocSinhSelected: (data: IStudentMedicalHistoryHocSinh): IStudentMedicalHistoryChangeHocSinhSelected => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.CHANGE_HOC_SINH_SELECTED,
			payload: data
		}
	},
	loadHealthProblemByHocSinhStart: (request: IHealthProblemByHocSinhRequest): IStudentMedicalHistoryLoadByHocSinhStart => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_START,
			payload: request
		}
	},
	loadHealthProblemByHocSinhSuccess: (data: HealthProblemHocSinhItemResponse[]): IStudentMedicalHistoryLoadByHocSinhSuccess => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_SUCCESS,
			payload: data
		}
	},
	loadHealthProblemByHocSinhError: (message: string): IStudentMedicalHistoryLoadByHocSinhErr => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_ERROR,
			payload: message
		}
	},
	changeHealthProblems: (data: HealthProblemHocSinhItemResponse[]): IStudentMedicalHistoryChangeHealthProblems => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.CHANGE_HEALTH_PROBLEMS,
			payload: data
		}
	},
	saveStudentMedicalHistoryStart: (request: IHealthProblemHocSinhItemRequest): IStudentMedicalHistorySaveStart => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.SAVE_START,
			payload: request
		}
	},
	saveStudentMedicalHistorySuccess: (): IStudentMedicalHistorySaveSuccess => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.SAVE_SUCCESS
		}
	},
	saveStudentMedicalHistoryError: (message: string): IStudentMedicalHistorySaveErr => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	showStudentMedicalHistoryConfirm: (): IStudentMedicalHistoryShowConfirm => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.SHOW_CONFIRM
		}
	},
	closeStudentMedicalHistoryConfirm: (): IStudentMedicalHistoryCloseConfirm => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.CLOSE_CONFIRM
		}
	},
	deleteStudentMedicalHistoryStart: (request: IHealthProblemByHocSinhRequest): IStudentMedicalHistoryDeleteStart => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.DELETE_START,
			payload: request
		}
	},
	deleteStudentMedicalHistorySuccess: (): IStudentMedicalHistoryDeleteSuccess => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteStudentMedicalHistoryError: (message: string): IStudentMedicalHistoryDeleteErr => {
		return {
			type: eStudentMedicalHistoryActionTypeIds.DELETE_ERROR,
			payload: message
		}
	}
}
